// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"W3-z","dimensionLabel":"X3-z","styleChooserControlWrapper":"Y3-z","styleChooserControl":"Z3-z","disabled":"_3-z","giftCard":"a4-z","styleChooserText":"b4-z"};